/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OperatingStatementAccountCategory } from './OperatingStatementAccountCategory';
/**
 * The chart-of-accounts match assigned to a line item by the AI parser
 * or by a user manual override.
 *
 * `confidence: 'user'` means the match was set manually
 */
export type ParsedOSLineItemCategoryMatch = {
    id: number;
    name: string | null;
    category: OperatingStatementAccountCategory;
    confidence: ParsedOSLineItemCategoryMatch.confidence;
};
export namespace ParsedOSLineItemCategoryMatch {
    export enum confidence {
        HIGH = 'high',
        MEDIUM = 'medium',
        LOW = 'low',
        USER = 'user',
    }
}

